// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"print-summary_wrapper__3Gp9m","title":"print-summary_title__3TJDZ","subTitle":"print-summary_subTitle__2Ths8"};